import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { StateListType } from 'app/types';
import { inspectionApi } from './api';

type InitialState = {
  currentTab: string;
  job: StateListType<any>;
  calendar: StateListType<any>;
};
const initialState: InitialState = {
  currentTab: 'inspection-job',
  job: {
    total: 0,
    pagination: {
      current: 1,
      pageSize: 10
    },
    filter: {
      result: ['all'],
      status: ['all']
    },
    sorter: {
      value: 'createdAt',
      direction: 'desc'
    },
    data: [],
    status: '',
    error: ''
  },
  calendar: {
    total: 0,
    pagination: {
      current: 1,
      pageSize: 10
    },
    filter: {},
    sorter: {},
    data: [],
    status: '',
    error: ''
  }
};

const slice = createSlice({
  name: 'inspection',
  initialState,
  reducers: {
    updateJobPagination: (state, action) => {
      return {
        ...state,
        job: {
          ...state.job,
          pagination: {
            ...action.payload
          }
        }
      };
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      inspectionApi.endpoints.getInspections.matchPending,
      (state, action) => {
        state.job = {
          ...state.job,
          status: action.meta.requestStatus,
          pagination: {
            current: action.meta.arg.originalArgs.current,
            pageSize: action.meta.arg.originalArgs.pageSize
          }
        };
      }
    );
    builder.addMatcher(
      inspectionApi.endpoints.getInspections.matchFulfilled,
      (state, action) => {
        state.job = {
          ...state.job,
          status: action.meta.requestStatus,
          data: action.payload.data as any,
          total: action.payload.pagination.total,
          pagination: {
            current: action.payload.pagination.page,
            pageSize: action.payload.pagination.pageSize
          }
        };
      }
    );
  }
});

export const { updateJobPagination } = slice.actions;
export default slice.reducer;

const rootState = (state: RootState) => state;

export const inspectionSelector = createSelector(
  rootState,
  (state) => state.inspection
);

export const inspectionJobSelector = createSelector(
  (state: RootState) => state,
  (state) => state.inspection.job
);

export const inspectionCalendarSelector = createSelector(
  rootState,
  (state) => state.inspection.calendar
);

export const inspectionCurrentTabSelector = createSelector(
  rootState,
  (state) => state.inspection.currentTab
);

export const inspectionStatisticSelector = createSelector(
  rootState,
  (state) => ({
    job: state.inspection.job.total,
    calendar: state.inspection.calendar.total
  })
);
